// @flow
import * as React from 'react';
import styled from 'styled-components';
import type { CurrentUser } from 'api/currentUser';
import { trackClicked, trackEventOnce } from 'utils/analytics';
import ResumeDatabaseResponseContainer from 'containers/ResumeDatabaseResponseContainer';
import Box from 'components/Box';
import Icon from 'components/Icon';
import Button, { SecondaryButtonRouterLink } from 'components/Button';
import { fontWeights, gutterWidth, colors, transition } from 'theme';

const { useEffect } = React;

const CloseButton = styled(Button)`
  opacity: 0.7;
  transition: all ${transition};
  &:hover {
    opacity: 1;
  }
`;

const ResumeDatabaseBanner = ({
  currentUser
}: {
  currentUser: CurrentUser
}) => {
  useEffect(() => {
    trackEventOnce('Displayed: Resume Database Ad', {
      context: 'Header Banner'
    });
  }, []);

  return (
    <Box
      data-qa-id="banner-ad"
      data-ad-type="resume-database"
      position="relative"
      zIndex={200}
      bg={colors.waterBlue}
      color="white"
    >
      <Box
        position="absolute"
        left={0}
        top={0}
        width={1}
        height="100%"
        backgroundImage="url('/static/images/resume-database-banner.jpg')"
        backgroundSize="cover"
        backgroundPosition="center"
        opacity="0.33"
      />
      <Box
        position="relative"
        minHeight={[80, null, null, 92]}
        width={1}
        px={gutterWidth / 2}
        py={12}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box pr={10} fontSize={[14, 16, null, 18]}>
          <Box
            mr="8px"
            display={['block', null, null, 'inline']}
            fontWeight={fontWeights.semiBold}
          >
            {/* TRANSLATORS: Resume database promotional banner */ getText(
              'Welcome to Idealist!'
            )}
          </Box>
          {/* TRANSLATORS: Resume database promotional banner */ getText(
            `Let hiring managers know you're open to opportunities.`
          )}
        </Box>

        <Box display="flex" alignItems="center" flex="0 0 auto">
          <SecondaryButtonRouterLink
            to="/dashboard/employment-profile/get-discovered"
            mr={16}
            square
            reverse
            onClick={() => {
              trackClicked('Add Resume', {
                context: 'Banner'
              });
            }}
          >
            <Box minHeight={24} display="flex" alignItems="center">
              <Box display={['none', null, null, 'block']}>
                {currentUser.resumeId
                  ? getText('Share Your Resume')
                  : getText('Add Your Resume')}
              </Box>
              <Box display={['block', null, null, 'none']}>
                {currentUser.resumeId
                  ? getText('Share Resume')
                  : getText('Add Resume')}
              </Box>
            </Box>
          </SecondaryButtonRouterLink>

          <ResumeDatabaseResponseContainer>
            {({ dismiss }) => (
              <CloseButton
                data-qa-id="close-banner-ad-button"
                onClick={() => {
                  dismiss();
                  trackClicked('Dismiss Resume Database CTA', {
                    context: 'Banner'
                  });
                }}
              >
                <Icon name="close" width={16} fill="currentColor" />
              </CloseButton>
            )}
          </ResumeDatabaseResponseContainer>
        </Box>
      </Box>
    </Box>
  );
};

export default ResumeDatabaseBanner;
